export const referralLocalStorageKey = "referralCode";
export const referralQueryParamKey = "referral";
